export const storySignInCopy = {
  en: {
    product: "xHalo Story",
    headline: <>Write stories<br />that <em>remember.</em></>,
    tagline: "Story understands your characters, world, plot, and continuity—so you can write with confidence.",
    welcome: "Welcome back",
    description: "Sign in to continue to Story",
    memory: ["Story Memory", "Tracks characters, events, and story details across your work."],
    bible: ["Story Bible", "Builds a living knowledge base for your canon, world, and lore."],
    intelligence: ["Narrative Intelligence", "Understands structure, tension, pacing, and continuity."],
    workflow: ["From Idea to Novel", "Supports the full workflow from concept to finished draft."],
    or: "or",
    magic: "Email me a magic link",
    terms: "By continuing, you agree to our",
    termsLink: "Terms of Service",
    privacyLink: "Privacy Policy",
    appearance: "Appearance",
  },
  "zh-Hans": {
    product: "xHalo Story",
    headline: <>写下会<br /><em>记得</em>的故事。</>,
    tagline: "Story 理解你的人物、世界、情节与连续性，让每一次创作都有所依凭。",
    welcome: "欢迎回来",
    description: "登录后继续进入 Story",
    memory: ["故事记忆", "持续追踪作品中的人物、事件与关键细节。"],
    bible: ["故事圣经", "为 Canon、世界观与设定建立活的知识库。"],
    intelligence: ["叙事智能", "理解结构、张力、节奏与前后连续性。"],
    workflow: ["从灵感到长篇", "覆盖从概念、写作到完成定稿的完整流程。"],
    or: "或",
    magic: "发送魔法登录链接",
    terms: "继续即表示你同意我们的",
    termsLink: "服务条款",
    privacyLink: "隐私政策",
    appearance: "外观",
  },
  "zh-Hant": {
    product: "xHalo Story",
    headline: <>寫下會<br /><em>記得</em>的故事。</>,
    tagline: "Story 理解你的人物、世界、情節與連續性，讓每一次創作都有所依憑。",
    welcome: "歡迎回來",
    description: "登入後繼續進入 Story",
    memory: ["故事記憶", "持續追蹤作品中的人物、事件與關鍵細節。"],
    bible: ["故事聖經", "為 Canon、世界觀與設定建立活的知識庫。"],
    intelligence: ["敘事智能", "理解結構、張力、節奏與前後連續性。"],
    workflow: ["從靈感到長篇", "涵蓋從概念、寫作到完成定稿的完整流程。"],
    or: "或",
    magic: "傳送魔法登入連結",
    terms: "繼續即表示你同意我們的",
    termsLink: "服務條款",
    privacyLink: "隱私政策",
    appearance: "外觀",
  },
  ja: {
    product: "xHalo Story",
    headline: <>記憶する<br /><em>物語</em>を書こう。</>,
    tagline: "Story は人物、世界、プロット、連続性を理解し、自信を持って執筆できるよう支えます。",
    welcome: "おかえりなさい",
    description: "サインインして Story を続ける",
    memory: ["ストーリーメモリー", "人物、出来事、作品全体の重要な詳細を追跡します。"],
    bible: ["ストーリーバイブル", "カノン、世界、ロアの生きた知識ベースを構築します。"],
    intelligence: ["ナラティブインテリジェンス", "構成、緊張感、ペース、連続性を理解します。"],
    workflow: ["アイデアから小説へ", "構想から完成稿までのワークフローを支援します。"],
    or: "または",
    magic: "マジックリンクを送信",
    terms: "続行すると、以下に同意したものとみなされます：",
    termsLink: "利用規約",
    privacyLink: "プライバシーポリシー",
    appearance: "外観",
  },
  ko: {
    product: "xHalo Story",
    headline: <>기억하는<br /><em>이야기</em>를 쓰세요.</>,
    tagline: "Story는 인물, 세계, 플롯과 연속성을 이해해 자신 있게 집필하도록 돕습니다.",
    welcome: "다시 오신 것을 환영합니다",
    description: "로그인하고 Story를 계속하세요",
    memory: ["스토리 메모리", "작품 속 인물, 사건과 핵심 세부 정보를 추적합니다."],
    bible: ["스토리 바이블", "캐논, 세계와 설정을 위한 살아 있는 지식 기반을 만듭니다."],
    intelligence: ["내러티브 인텔리전스", "구조, 긴장, 속도와 연속성을 이해합니다."],
    workflow: ["아이디어에서 소설까지", "구상부터 완성 원고까지 전체 흐름을 지원합니다."],
    or: "또는",
    magic: "매직 링크 보내기",
    terms: "계속하면 다음에 동의하는 것으로 간주됩니다:",
    termsLink: "서비스 약관",
    privacyLink: "개인정보 처리방침",
    appearance: "화면 모드",
  },
} as const;
